/*🤫
🤫
🤫
🤫
🤫
🤫*/

export * from "./utils/cookie";
export const {
  cookie,
  cookie: { exists, get, remove, set },
} = window.o_util;
